import { TipoMovimentacao } from '@app/models/processo-movimentacao';

export class PrazoGerenciamento {
  Id: number;
  ProcessoId: number;
  ProcessoFicha: string;
  Usuario: string;
  Descricao: string;
  Cliente: string;
  ClienteId: number;
  Data: string;
  Prazo: string;
  PrazoInterno: string;
  PrazoFatal: string;
  PrazoConcluido: boolean;
  RealizadoUsuario: string;
  RealizadoData: string;
  DataAgendada?: string;
  Realizado: boolean;
  ProtocoladoUsuario: string;
  ProtocoladoData: string;
  Protocolado: boolean;
  Status: string;
  EncaminhadoUsuarioId: number;
  EncaminhadoUsuario: string;
  EncaminhadoRealizadoData: string;
  EncaminhadoRealizado: boolean;
  EncaminhadoMeAviseId: number;
  EncaminhadoMeAviseDescricao: string;
  TipoMovimentacaoId: number;
  MovimentacaoDescricao: string;
  checked: boolean;
}

export class PrazoGerenciamentoLista {
  Data: string;
  Tipo: string;
  Prazos: Array<PrazoGerenciamento>;
}

export class PrazoGerenciamentoPesquisa {
  FuncionarioId: number;
  DataInicial: string;
  DataFinal: string;
  DataFatal: string;
  Realizado: number;
  Protocolado: number;
  Estado: number;
  FiltrarDataPor: string;
  TipoMovimentacao: TipoMovimentacao;
  MeAviseTipoId?: number;
  UnidadeId: number;
  TipoId: number;
  // TipoOrdenamento: "CRESCENTE" | "DECRESCENTE";
}

export class EncaminharPrazo {
  UsuarioId: number;
  MeAviseId: number;
  Descricao: string;
  MovimentacaoId: number;
  EncaminhadoId: number;
}
